import { useTranslation } from 'react-i18next';

import RadarChart from 'components/RadarChart';
import ViewSDQ from 'pages/Users/Detail/AnswerResult/_components/ViewSDQ';

const QuestionnaireResult = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full px-6 py-4 bg-white">
      <p className="font-bold text-[22px]">{t('SURVEY_RESULT')}</p>

      <div className="flex mt-6 gap-6 h-[calc(100%-33px-24px)]">
        <div className="w-1/2 h-full border border-solid border-gray-651">
          <div className="px-4 py-2 border-b border-solid border-gray-651 h-[42px]">
            <p className="font-bold">{t('ANALYSIS_RESULT')}</p>
          </div>

          <div className="p-1 h-[calc(100%-42px-8px)]">
            <div className="mt-2 overflow-x-hidden overflow-y-auto h-full">
              {data?.analysis_content?.analysis_results?.score_summary && (
                <div className="w-full h-50">
                  <RadarChart color={false} data={data?.analysis_content?.analysis_results?.score_summary} />
                </div>
              )}
              {data?.analysis_content?.analysis_results?.evaluation?.summary && (
                <>
                  <div className="p-4">
                    <div
                      className="mt-6 text-black-102"
                      dangerouslySetInnerHTML={{
                        __html: t('NOT_DIAGNOSTIC_TOOL'),
                      }}
                    />
                  </div>
                  <div className="p-4">
                    <div
                      className="text-sm"
                      dangerouslySetInnerHTML={{
                        __html: data?.analysis_content?.analysis_results?.evaluation?.summary,
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="w-1/2 border border-solid border-gray-651 h-full overflow-hidden">
          <div className="px-4 py-2 border-b border-solid border-gray-651" id="title-section">
            <p className="font-bold">{t('INPUT_CONTENT')}</p>
          </div>

          <div className="mt-2 h-[calc(100%-41px-8px)]">{data && <ViewSDQ id={data?.id} disableColor={true} />}</div>
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireResult;
